<script setup lang="ts">
defineProps<{
  vertical?: boolean
}>()
</script>

<template>
  <dl class="flex flex-wrap m-0 gap-x-8 gap-y-4" :class="{ 'flex-col': vertical }">
    <slot></slot>
  </dl>
</template>
